import { services } from '@octadesk-tech/services'
import store from '@/store'
import { getParameterHeaders } from './headers'

export const searchUserProducts = async keyword => {
  const headers = getParameterHeaders()

  const client = await services.createClient('persons', {
    headers
  })

  const { user } = store.getters

  if (user && user.email && user.email.length) {
    const response = await client.get(
      `/products/search?email=${user.email}&keyword=${keyword}`
    )
    return response.data
  }

  return []
}
